// Typelizer digest 920fcbfea36ba657d653f6106e95cc66
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /educators/invitations */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/invitations', {}, options),
    method: 'post',
  }),

  /** GET /educators/invitations/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/invitations/new', {}, options),
    method: 'get',
  }),

  /** GET /educators/invitations/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/invitations/:id', params, options),
    method: 'get',
  }),
}
